import { render, staticRenderFns } from "./LegButton.vue?vue&type=template&id=9dde4e4c"
import script from "./LegButton.vue?vue&type=script&lang=js"
export * from "./LegButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports